<template>
  <el-card>
    <div class="section-title">{{ $t('person.basic') }}</div>
    <el-row v-if="needCompanyInfo" type="flex" style="margin-right: 30px;">
      <el-col class="logo-block">
        <img class="pic" :src="logoUrl" alt="logo">
      </el-col>
    </el-row>
    <el-row style="width: 500px;">
      <el-col class="info-block">
        <el-form
          :model="form"
          :inline-message="true"
          label-position="left"
          label-width="140px"
        >
          <el-form-item v-if="needCompanyInfo || isAppeal" :label="companyLabel" prop="companyName">
            {{ form.companyName }}
          </el-form-item>
          <el-form-item v-if="needCompanyInfo" :label="$t('person.legalPerson')" prop="corporation">
            {{ form.corporation }}
          </el-form-item>
          <el-form-item v-if="!needCompanyInfo && !isAppeal" label="企业微信名：" prop="rtxName">
            {{ form.rtxName }}
          </el-form-item>
          <el-form-item :label="$t('person.email')" prop="email">
            {{ form.email }}
          </el-form-item>
          <el-form-item v-if="needCompanyInfo" :label="$t('person.address')" prop="cpAddress">
            {{ form.cpAddress }}
          </el-form-item>
          <el-form-item :label="$t('person.phone')" prop="phoneNum">
            {{ form.phoneNum }}
          </el-form-item>
          <!-- <el-form-item v-if="needCompanyInfo" label="投资公司渠道标识：" prop="channelId">
            {{ form.channelId }}
          </el-form-item> -->
          <el-form-item v-if="needCompanyInfo" :label="$t('person.desc')" prop="companyDesc">
            {{ form.companyDesc }}
          </el-form-item>
          <el-form-item v-if="form.roleType === 2" :label="$t('person.cpCompany')">
            {{ form.relateCompanyList.map(item => item.relateCompanyName).join(',') }}
          </el-form-item>
          <el-form-item
            v-if="needCompanyInfo"
            :label="$t('person.agentCompany')"
          >
            {{ form.agentCompanyList.map(item => item.agentCompanyName).join(',') }}
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="center">
      <el-alert
        v-if="userInfo.level === REJECT"
        :title="$t('person.profileReject')"
        type="error"
        :closable="false"
        :description="form.checkInfo"
        show-icon
      >
      </el-alert>
      <el-button type="info" :disabled="true" v-if="userInfo.level === REGISTERED">{{ $t('person.profileAuditing') }}</el-button>
      <el-button v-else type="primary" @click="handleEditInfo">{{ $t('person.edit') }}</el-button>
    </div>
  </el-card>
</template>

<script>
import cloneDeep from 'lodash-es/cloneDeep'
import { mapGetters, mapState } from 'vuex'
import { UserLevel } from '@/utils/constants'
import { IDTypeMap, ROLE_TYPE_ENUM, singerTypeMap } from './const'
import { areaMap, genreMap } from '@/views/singer/mixin'

export default {
  name: 'PersonIndex',
  data() {
    return {
      IDTypeMap,
      singerTypeMap,
      areaMap,
      genreMap,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    ...mapState({
      form: state => {
        let cp
        const { user } = state
        const roleType = user.userInfo.roleType

        if ([
          ROLE_TYPE_ENUM.COMPANY.code,
          ROLE_TYPE_ENUM.OTHER.code,
          ROLE_TYPE_ENUM.PRIVATE.code,
          ROLE_TYPE_ENUM.ORGANIZATION.code
        ].includes(roleType)) {
          cp = user.company ? user.company : {
            companyPhotoList: [],
            agentCompanyList: []
          }
        } else {
          cp = user.editorObj
        }

        cp = cloneDeep(cp) || {}
        cp.agentCompanyList = user.agentCompanyList
        cp.relateCompanyList = user.relateCompanyList
        cp.roleType = roleType
        cp.channelId = user.channelId
        return cp
      }
    }),
    REGISTERED() {
      return UserLevel.REGISTERED.code
    },
    REJECT() {
      return UserLevel.REJECT.code
    },
    logoUrl() {
      const photo = (this.form.companyPhotoList && this.form.companyPhotoList[0]) || {}
      return photo.url || ''
    },
    needCompanyInfo() {
      return [1, 5].includes(this.form.roleType)
    },

    isAppeal() {
      return [ROLE_TYPE_ENUM.PRIVATE.code, ROLE_TYPE_ENUM.ORGANIZATION.code].includes(this.userInfo.roleType)
    },
    companyLabel() {
      return this.needCompanyInfo ? this.$t('person.companyName')
        : this.userInfo.roleType === ROLE_TYPE_ENUM.PRIVATE.code ? '联系人姓名'
          : '组织机构名'
    }
  },
  methods: {
    handleEditInfo() {
      this.$router.push({ name: 'personEdit' })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.pic {
  height: 200px;
  width: 200px;
  text-align: center;
  box-shadow: #ccc 0 0 10px;
}

.logo-block {
  width: 300px;
  margin-right: 24px;
}
.info-block {
  flex-grow: 1;
}
.el-form-item {
  margin: 0;
  padding: 8px 0;

  &.img-item {
    img {
      width: 150px;
      height: 150px;

      & + img {
        margin-left: 10px;
      }
    }
  }

  &:not(.img-item) {
    /deep/ .el-form-item__content {
      border-bottom: 1px solid rgba($primary, .5);
    }
  }
}
</style>
